import ContactBg from "./../Assets/contactBG.jpg";
import ContactForm from "./ContactForm";
import Footer from "../Components/Footer/Footer";
import React from "react";
import { Box, Grid, Link, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";

const ContactPage = () => {

  return (
    <>
      <Helmet>
        <title>Contact | Đông Hưng Viên Bakery</title>
      </Helmet>

      <Box
        sx={{
          backgroundImage: `url(${ContactBg})`,
          backgroundSize: 'cover',
          color: 'white',
        }}
      >
        <Box
          sx={{
            background: 'rgba(0,0,0,0.7)',
            p: 4,
            display: 'flex',
            justifyContent: 'center',
            pt: 15,
          }}
        >
          <Box sx={{ maxWidth: '1080px' }}>
            <Typography
              variant="h3"
              align="left"
              sx={{
                fontSize: { xs: '40px', sm: '60px', md: '80px' },
                fontWeight: '700',
                fontFamily: 'Poiret One',
                letterSpacing: '12px',
                pb: 5,
              }}
              gutterBottom
            >
              CONTACT
            </Typography>

            <Grid container spacing={8}>
              {/* LEFT: Contact Form */}
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    py: 4,
                  }}
                >
                  <ContactForm />
                </Box>
              </Grid>

              {/* RIGHT: Contact Info */}
              <Grid item xs={12} md={6}>
                <Box sx={{ borderRadius: 2 }}>
                  <Typography
                    sx={{
                      fontSize: '40px',
                      color: '#2ea3f2',
                      fontWeight: '700',
                      lineHeight: '45px',
                    }}
                    variant="h2"
                  >
                    (714) 891-4404
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: '14px',
                      color: '#fff',
                      lineHeight: '1.4em',
                      fontWeight: '700',
                      textTransform: 'uppercase',
                      pt: 3,
                      pb: 2,
                    }}
                  >
                    Address:
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: '16px',
                      color: '#fff',
                      lineHeight: '1.4em',
                      fontWeight: '400',
                      textTransform: 'capitalize',
                      py: 0,
                    }}
                  >
                    8536 Westminster Ave, Westminster, CA 92683
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: '14px',
                      color: '#fff',
                      lineHeight: '1.4em',
                      fontWeight: '700',
                      textTransform: 'uppercase',
                      pt: 3,
                      pb: 2,
                    }}
                  >
                    Opening Hours:
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: '16px',
                      color: '#fff',
                      lineHeight: '1.4em',
                      fontWeight: '400',
                      textTransform: 'capitalize',
                      py: 0,
                    }}
                  >
                    Daily 6:30am – 8pm
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: '14px',
                      color: '#fff',
                      lineHeight: '1.4em',
                      fontWeight: '700',
                      textTransform: 'uppercase',
                      pt: 3,
                      pb: 2,
                    }}
                  >
                    Email:
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      fontSize: '16px',
                      color: '#fff',
                      lineHeight: '1.4em',
                      fontWeight: '400',
                      py: 0,
                    }}
                  >
                    <Link
                      href="mailto:info@donghungvienbakery.com"
                      color="inherit"
                    >
                      info@donghungvienbakery.com
                    </Link>
                  </Typography>
                  {/* Social Icons Removed */}
                </Box>
              </Grid>
            </Grid>

            <Box sx={{ mt: 4, textAlign: 'center' }}>
              {/* 
                Uncomment if you want to display Google Map:
                
                <iframe
                  title="Google Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3169.9298714957526!2d-117.96420482449493!3d33.759582027318516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dd279b9cda3cf1%3A0xa1b75bcfd913470!2sDong%20Hung%20Vien%20Bakery!5e0!3m2!1sen!2sus!4v1681067261990!5m2!1sen!2sus"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>
              */}
            </Box>
          </Box>
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default ContactPage;